import { ApiCore } from './utilities/core'


export const userAPI = new ApiCore({
    getAll: true,
    getSingle: true,
    put: true,
    url: 'api/user'
})
